// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2lTGO","tab":"ProcedureTabs_tab__xWrUZ"};